import React, { useEffect, useState, useId } from 'react';
import Formation from './Formation';
import ModuleWrapper from './ModuleWrapper';
import Swal from 'sweetalert2';
const vsprintf = require('sprintf-js').vsprintf;
const ModulesStep = ({ pll, formData, setFormData, page, setPage, attributes }) => {
    const minDaysConditions = () => {
        if (attributes.dispositif.type != "multiple")
            return true;
        return attributes.dispositif.days - formData.selectedDays < 1;
    };
    const mandatoryConditions = () => {
        if (attributes.dispositif.type != "multiple")
            return true;
        let allIsOk = true;
        attributes.dispositif.mandatoryFormationsIds.forEach((value) => {
            if (formData.formations.includes(value) == false)
                allIsOk = false;
        });
        return allIsOk;
    };
    const [showMinDaysError, setMinDaysConditions] = useState(false);
    const [citiesNode, setCitiesNode] = useState("");
    const [allModules, setAllModules] = useState(attributes.dispositif.type != "multiple" ? attributes.formation.modules.sort((a, b) => a.fdate > b.fdate) : "");
    const [showMandatoryError, setMandatoryError] = useState(false);
    useEffect(() => {
        setMinDaysConditions(!minDaysConditions());
        setMandatoryError(!mandatoryConditions());
        if (attributes.dispositif.type != "multiple") {
            let cities = [];
            let i = 0;
            allModules.forEach(element => {
                if (!cities.includes(element.location)) {
                    cities.push(element.location);
                }
                i++;
                if (allModules.length == i) {
                    cities.sort();
                    setCitiesNode([React.createElement("option", { value: "all" }, pll("Filtrer par ville"))].concat(cities.map(element => {
                        return React.createElement("option", { value: element }, element);
                    })));
                }
            });
            // setCitiesNode([<option value="all">{pll("Filtrer par ville")}</option>].concat(allModules.map(element => {
            //   if (!cities.includes(element.location)) {
            //     cities.push(element.location);
            //     return <option value={element.location}>{element.location}</option>
            //   }
            // })));
        }
        return () => {
            // this now gets called when the component unmounts
        };
    }, [formData]);
    const handleCity = (e) => {
        let value = (e.currentTarget.value);
        setAllModules(allModules.map(element => {
            element.visible = element.location == value || value == "all";
            return element;
        }));
    };
    let chosen = "";
    let leftDays = attributes.dispositif.days - formData.selectedDays;
    let minDaysError = vsprintf(pll("Attention, il vous manque <strong>%s jour%s</strong> pour compléter votre formation."), [leftDays, leftDays > 1 ? "s" : ""]);
    let mandatoryError = pll("Certaines formations sont obligatoires, il vous faut impérativement les inclure dans votre formation globale.");
    const nextHandler = (e) => {
        e.preventDefault();
        if (!minDaysConditions()) {
            Swal.fire({
                icon: 'error',
                title: 'Erreur !',
                html: minDaysError,
                showConfirmButton: true,
                allowOutsideClick: true
            });
        }
        else {
            setPage(page + 1);
        }
    };
    if (attributes.dispositif.type == "multiple") {
        chosen = (attributes.dispositif.formations.map((element) => {
            return React.createElement("div", { key: useId() },
                React.createElement(Formation, { pll: pll, element: element, formData: formData, setFormData: setFormData, attributes: attributes }));
        }));
    }
    else {
        chosen = React.createElement(ModuleWrapper, { pll: pll, formData: formData, setFormData: setFormData, attributes: attributes, modules: allModules, options: { formationId: attributes.formationId, page: page, setPage: setPage } });
    }
    const fiche = attributes.dispositif.file ? React.createElement("a", { href: attributes.dispositif.file, className: "Button", target: "_blank" }, pll("Télécharger les fiches")) : "";
    return (React.createElement("div", { className: `step registration ${attributes.dispositif.type}` },
        attributes.dispositif.type == "multiple" ?
            (React.createElement(React.Fragment, null,
                React.createElement("h2", { className: "h2-as-h1" }, pll("Principe du dispositif")),
                React.createElement("div", { className: "title with-actions start right" },
                    React.createElement("div", { className: "elm", dangerouslySetInnerHTML: { __html: attributes.dispositif.description } }),
                    React.createElement("div", { className: "actions" }, fiche))))
            : React.createElement(React.Fragment, null,
                React.createElement("div", { className: "topinfos", dangerouslySetInnerHTML: { __html: attributes.formation.step } }),
                React.createElement("div", { className: "filters fields" },
                    React.createElement("div", { className: `form-row` },
                        React.createElement("div", { className: "form-control" },
                            React.createElement("label", { htmlFor: "city" }, pll("Villes")),
                            React.createElement("select", { id: "city", name: "city", onChange: handleCity }, citiesNode))),
                    React.createElement("div", { className: `form-row` }),
                    React.createElement("div", { className: `form-row` }))),
        React.createElement("div", { className: "chosen" }, chosen),
        attributes.dispositif.type == "multiple" ?
            React.createElement("div", { className: "actions start" },
                React.createElement("div", { className: "days" },
                    React.createElement("p", { className: "label" }, pll("Total:")),
                    React.createElement("p", { className: "value" },
                        formData.selectedDays,
                        " ",
                        formData.selectedDays > 1 ? "jours" : "jour"),
                    showMinDaysError ? (React.createElement("div", { className: "errordays", dangerouslySetInnerHTML: { __html: minDaysError } })) : "",
                    showMandatoryError ? (React.createElement("div", { className: "errordays", dangerouslySetInnerHTML: { __html: mandatoryError } })) : ""),
                React.createElement("button", { onClick: nextHandler, disabled: (showMinDaysError || showMandatoryError), className: `Button ${(showMinDaysError || showMandatoryError ? "disabled" : "")}` }, pll("Suivant")))
            : ""));
};
export default ModulesStep;
